import { render, staticRenderFns } from "./CopyEvent.vue?vue&type=template&id=41090aea&scoped=true"
import script from "./CopyEvent.vue?vue&type=script&lang=js"
export * from "./CopyEvent.vue?vue&type=script&lang=js"
import style0 from "./CopyEvent.vue?vue&type=style&index=0&id=41090aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41090aea",
  null
  
)

export default component.exports